import { AdminRoutes } from "config/routes";
import { AuthGuidePage } from "./AuthGuidePage";
import { resetPasswordGuideMarkdown } from "./content/resetPasswordGuide";

export const ResetPasswordGuide = () => (
  <AuthGuidePage
    markdown={resetPasswordGuideMarkdown}
    actionPath={AdminRoutes.ResetPasswordRequest}
    actionLabel="Go to Reset Password"
  />
);
